import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getThirdAnalyses = asyncThunkWrapper({ 
  model: 'thirdAnalyses', 
  action: 'getThirdAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', { input: ['id', 'filename'] }, 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/third_flow/third_analyses', { params });

    return response.data;
  } 
});
export const getThirdAnalysis = asyncThunkWrapper({ 
  model: 'thirdAnalyses', 
  action: 'getThirdAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = [
      'id', 
      { input: ['id', 'filename', 'content_type', 'url'] }, 
      { result: ['id', 'filename', 'content_type', 'url'] }, 
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/third_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalThirdAnalyses = createAction('thirdAnalyses/clearLocalThirdAnalyses');
export const clearLocalActiveThirdAnalysis = createAction('thirdAnalyses/clearLocalActiveThirdAnalysis');